import AppPage from "shared/design-system/components/app-page";

const GuidaPage: React.FC = () => {
	return <AppPage title="Guida">guida</AppPage>;
};
export default GuidaPage;
